import gql from 'graphql-tag'

export const UPLOAD_USERS = gql`
    mutation uploadUsers (
        $data: JSON!
    ) {
        uploadUsers (
            data: $data
        )
    }
`

export const GET_PAGINATED_USER_TOPICS = gql`
    query getUserTopics (
        $page: Int!
        $pageSize: Int
        $filter: UserTopicsFilter
    ) {
        getUserTopics (
            page: $page
            pageSize: $pageSize
            filter: $filter
        ) {
            list {
                id
                uid
                topic_uid
                user_uid
                date_attended
                created_at
                user {
                    id
                    uid
                    username
                    email
                    role_uid
                    role {
                        id
                        uid
                        name
                    }
                    profile {
                        id
                        uid
                        user_uid
                        fullname
                        firstname
                        middlename
                        lastname
                    }
                    fb_profile_url
                    is_activated
                }
                topic {
                    id
                    uid
                    name
                }
            }
            pagination
        }
    }
` 

export const ADD_USER = gql`
    mutation addUser (
        $fullname: String!
        $email: String!
        $date_attended: String!
        $topic: String!
    ) {
        addUser (
            fullname: $fullname
            email: $email
            date_attended: $date_attended
            topic: $topic
        )
    }
`

export const DELETE_USER_TOPIC = gql`
    mutation deleteUserTopic (
        $user_topic_uid: String!
    ) {
        deleteUserTopic (
            user_topic_uid: $user_topic_uid
        )
    }
`

export const EDIT_USER_TOPIC_ENTRY = gql`
    mutation editUserTopicEntry (
        $fullname: String! 
        $email: String! 
        $date_attended: String! 
        $topic: String!
        $user_topic_uid: String!
    ) {
        editUserTopicEntry (
            fullname: $fullname
            email: $email
            date_attended: $date_attended
            topic: $topic
            user_topic_uid: $user_topic_uid
        )
    }
`